<template>
  <div v-if="adItem && adItem.content">
    <iframe
      class="ad-design"
      :src="adItem.content"
      frameborder="0"
    ></iframe>
  </div>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'

@Component({
  props: {
    adItem: {
      type: Object,
      default: null
    },
  }
})
export default class Embed extends Vue {}
</script>
